import { render, staticRenderFns } from "./ListagemIbuttons.vue?vue&type=template&id=c151a004&scoped=true"
import script from "./ListagemIbuttons.vue?vue&type=script&lang=js"
export * from "./ListagemIbuttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c151a004",
  null
  
)

export default component.exports